import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import "./BrandSelector.scss";
import { AgencyApi } from "../../../../utils/api/Agency";
import SearchIcon from "../../../../components/icons/SearchIcon";
import DownArrowIcon from "../../../../components/icons/DownArrowIcon";
import Loading from "../../../loading/Loading";
import CloseIcon from "../../../../components/icons/CloseIcon";

let searchTimer: any;
let initialLoading = true;

const BrandSelector = ({
  formik,
  countryCode,
}: {
  formik: any;
  countryCode?: string;
}) => {
  const [state, setState] = useState({
    agentListBox: false,
    listData: [],
    isLoading: true,
  });

  const onToggelBox = () => {
    setState({
      ...state,
      agentListBox: !state?.agentListBox,
    });
  };

  const onClickSelect = (data: any) => {
    formik.setFieldValue("brand_id", data?._id);
    formik.setFieldValue("brand_name", data?.name);

    setState({
      ...state,
      agentListBox: false,
    });

    let search_input: any = document.getElementById("brand-selector-id");
    if (search_input) search_input.value = "";

    getDataApi("");
  };

  const onClickRemove = () => {
    formik.setFieldValue("brand_id", "");
    formik.setFieldValue("brand_name", "");
  };

  const getDataApi = async (search: string) => {
    setState((prev) => ({ ...prev, isLoading: true }));
    try {
      let res: any = await AgencyApi?.getBrandList({
        search,
        country_code: countryCode || "",
      });

      if (res?.data?.success) {
        const docs = res?.data?.data?.docs ?? [];
        const allowedStatuses = ["active", "brand_locked"];

        const shortData = docs
          .filter((b: any) =>
            allowedStatuses.includes(String(b?.status || "").toLowerCase()),
          )
          .map((b: any) => ({
            _id: b?._id,
            name: b?.brand_name,
          }));

        setState((prev) => ({
          ...prev,
          isLoading: false,
          listData: shortData,
        }));
        initialLoading = false;
      } else {
        setState((prev) => ({ ...prev, isLoading: false }));
      }
    } catch (err) {
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  const onChangeSearch = (e: any) => {
    let search = e?.target?.value;
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => {
      getDataApi(search);
    }, 500);
  };

  useEffect(() => {
    initialLoading = true;
    getDataApi("");
  }, [countryCode]);

  return (
    <div className="brand-selector-container">
      {/* 1. Search Section */}
      <p className="brand-lable">Select brand</p>
      <div className="template-selector-container">
        {state?.agentListBox && (
          <div className="agent-selector-bg" onClick={onToggelBox}></div>
        )}

        <div className="filter-search-agent">
          <div className="filter-search-icon">
            <SearchIcon />
          </div>
          <input
            type="text"
            placeholder="Select Brand"
            className={`filter-search-input ${
              formik?.errors?.brand_id ? "selector-input-error" : ""
            }`}
            onClick={onToggelBox}
            onChange={onChangeSearch}
            id="brand-selector-id"
            autoComplete="off"
          />

          <div
            className={`filter-down-arrow-icon ${
              state?.agentListBox ? "open-box" : ""
            }`}
          >
            {initialLoading && state?.isLoading ? (
              <CircularProgress
                style={{ width: 16, height: 16, color: "black" }}
              />
            ) : (
              <div onClick={onToggelBox} style={{ display: "flex" }}>
                <DownArrowIcon />
              </div>
            )}
          </div>
        </div>

        <div
          className={`reporting-manager-list-container ${
            state?.agentListBox ? "" : "display-none"
          }`}
        >
          {state?.isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "10px",
              }}
            >
              <Loading />
            </div>
          ) : state?.listData?.length ? (
            state?.listData?.map((data: any) => (
              <div
                className={`reporting-manager-list-item`}
                key={data?._id}
                onClick={() => onClickSelect(data)}
              >
                <p className="item-profile-name">{data?.name}</p>
              </div>
            ))
          ) : (
            <div className="agent-list-not-found">
              <p>List not found!</p>
            </div>
          )}
        </div>
      </div>

      {formik?.values?.brand_id && (
        <div className="selected-brand-section">
          <p className="brand-lable">Selected brand</p>
          <div className="selected-brand-box">
            <span className="selected-brand-name">
              {formik?.values?.brand_name || "Selected Brand"}
            </span>
            <div className="remove-icon" onClick={onClickRemove}>
              <CloseIcon />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BrandSelector;
